import angular from 'angular';
import uiRouter from 'angular-ui-router';
import errorModule from '../error/error';
import homeComponent from './home.component';
import testRoutesComponent from './testRoutes/testRoutes.component';
import homeService from './home.service';
import template from './receipt/receipt.html';
import cancelledTemplate from './receipt/cancelledReceipt.html';
import sgoTemplate from './receipt/sgoReceipt.html';
import CodedError, {ERROR_CODE} from '../../util/CodedError';
import logo from './receipt/sections/logo.html';
import deliveryAddressPickUpByBox from './receipt/sections/deliveryAddressPickUpByBox.html';
import customerCare from './receipt/sections/customerCare.html';
import corporateCare from './receipt/sections/corporateCare.html';
import restaurantCare from './receipt/sections/restaurantCare.html';
import specialInstructions from './receipt/sections/specialInstructions.html';
import contactFreeInstructions from './receipt/sections/contactFreeInstructions.html';
import curbsidePickupInstructions from './receipt/sections/curbsidePickupInstructions.html';
import adjustmentBar from './receipt/sections/adjustmentBar.html';
import scheduledBar from './receipt/sections/scheduledBar.html';
import cancelledBar from './receipt/sections/cancelledBar.html';
import dinerBar from './receipt/sections/dinerBar.html';
import receiptBar from './receipt/sections/receiptBar.html';
import cancellationText from './receipt/sections/cancellationText.html';
import merchantInfo from './receipt/sections/merchantInfo.html';
import deliverBy from './receipt/sections/deliverBy.html';
import orderNumbers from './receipt/sections/orderNumbers.html';
import deliveryOrPickUpBox from './receipt/sections/deliveryOrPickUpBox.html';
import cateringBox from './receipt/sections/cateringBox.html';
import dinerBox from './receipt/sections/dinerBox.html';
import minAdvNoticeBox from './receipt/sections/minAdvNoticeBox.html';
import orderSummaryHeader from './receipt/sections/orderSummaryHeader.html';
import dinerSummaryHeader from './receipt/sections/dinerSummaryHeader.html';
import orderSummaryItems from './receipt/sections/orderSummaryItems.html';
import orderDinerSummaryRestaurant from './receipt/sections/orderDinerSummaryRestaurant.html';
import prepaidOrCash from './receipt/sections/prepaidOrCash.html';
import restaurantTaxExemptionNotice from './receipt/sections/restaurantTaxExemptionNotice.html';
import dinerTaxExemptionNotice from './receipt/sections/dinerTaxExemptionNotice.html';
import orderSummaryNapkinsAndUtensils from './receipt/sections/orderSummaryNapkinsAndUtensils.html';
import orderSummaryCoupons from './receipt/sections/orderSummaryCoupons.html';
import orderSummaryAdjustments from './receipt/sections/orderSummaryAdjustments.html';
import orderSummaryTotals from './receipt/sections/orderSummaryTotals.html';
import dinerSummaryTotals from './receipt/sections/dinerSummaryTotals.html';
import deliveryTotalSummary from './receipt/sections/deliveryTotalSummary.html';
import orderSummary from './receipt/sections/orderSummary.html';
import dinerSummaryRestaurant from './receipt/sections/dinerSummaryRestaurant.html';
import dinerSummaryCustomer from './receipt/sections/dinerSummaryCustomer.html';
import logoAndCustCare from './receipt/sections/logoAndCustCare.html';
import deliveryInfo from './receipt/sections/deliveryInfo.html';
import endOfOrder from './receipt/sections/endOfOrder.html';
import restaurantPage from './receipt/sections/restaurantPage.html';
import customerPage from './receipt/sections/customerPage.html';
import pageSeparator from './receipt/sections/pageSeparator.html';
import iconUpdate from './receipt/images/iconUpdate.html';
import orderSummaryCountAndInstructionsTag from './receipt/sections/orderSummaryCountAndInstructionsTag.html'
import dinerSummaryCount from './receipt/sections/dinerSummaryCount.html'
import foodPrepTimeModule from "../foodPrepTime/foodPrepTime";
import { OrderType, PREP_TIME_DEFAULTS } from '../foodPrepTime/foodPrepTimeConstants';

let homeModule = angular.module('home', [
  errorModule,
  foodPrepTimeModule,
  uiRouter
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $urlRouterProvider.otherwise('/error');

  $stateProvider
    .state('error', {
      url: '/error',
      component: 'error',
      resolve: {
        error: function(errorService) {
          const error = errorService.getError();
          return (error != null) ? error : new CodedError(undefined, ERROR_CODE.INVALID_TOKENS);
        }
      }
    })
    .state('home', {
      url: '/:authToken/:supervisorToken?foodPrepDuration',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService, $stateParams) {
          return homeService.getModel($stateParams.authToken, $stateParams.supervisorToken, $stateParams.foodPrepDuration);
        }
      }
    })
    .state('homeWithId', {
      url: '/{custId:[0-9]*}/:authToken/:supervisorToken?foodPrepDuration',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService, $stateParams) {
          return homeService.getModelWithId($stateParams.custId, $stateParams.authToken, $stateParams.supervisorToken,
            $stateParams.foodPrepDuration);
        }
      }
    })
    .state('test', {
      url: '/test',
      component: 'testRoutes',
      resolve: {}
    })
    .state('testGHD', {
      url: '/testGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testGHDeliveryOrder(); }
      }
    })
    .state('testPickup', {
      url: '/testPickup',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testPickupOrder(); }
      }
    })
    .state('testSelfDelivery', {
      url: '/testSelfDelivery',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) {
          return homeService.testSelfDeliveryOrder();
        }
      }
    })
    .state('testCash', {
      url: '/testCash',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) {
          return homeService.testCashOrder();
        }
      }
    })
    .state('testCashPickup', {
      url: '/testCashPickup',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) {
          return homeService.testCashPickupOrder();
        }
      }
    })
    .state('testGHDeliveryOrderWithOneItem', {
      url: '/testGHDeliveryOrderWithOneItem',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testGHDeliveryOrderWithOneItem(); }
      }
    })
    .state('testNonConfirmed', {
      url: '/testnonconfirmed',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testNonConfirmedOrder(); }
      }
    })
    .state('testUnconfirmedFuture', {
      url: '/testunconfirmedfuture',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testUnconfirmedFutureOrder(); }
      }
    })
    .state('testConfirmedFuture', {
      url: '/testconfirmedfuture',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testConfirmedFutureOrder(); }
      }
    })
    .state('testAdjustedOrder', {
      url: '/testadjustedpickup',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testAdjustedPickupOrder(); }
      }
    })
    .state('testAdjustedOrderWithRestaurantAdjustedTotal', {
      url: '/testadjustedwithrestauranttotals',
      component: 'home',
      resolve: {
          confirmTemplateModel: function(homeService) { return homeService.testAdjustedOrderWithRestaurantTotals(); }
      }
    })
    .state('testAdjustedOrderServiceFee', {
          url: '/testAdjustedOrderServiceFee',
          component: 'home',
          resolve: {
              confirmTemplateModel: function(homeService) { return homeService.testAdjustedOrderServiceFee(); }
      }
    })
    .state('testCancelledOrder', {
      url: '/testcancelled',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCancelledOrder(); }
      }
    })
    .state('testRedactedOrderNonGHD', {
      url: '/testRedactedOrderNonGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testRedactedOrderNonGHD(); }
      }
    })
    .state('testRedactedOrderGHD', {
      url: '/testRedactedOrderGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testRedactedOrderGHD(); }
      }
    })
    .state('testCateringAsapGHD', {
      url: '/testCateringAsapGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCateringAsapGHD(); }
      }
    })
    .state('testCateringFutureGHD', {
      url: '/testCateringFutureGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCateringFutureGHD(); }
      }
    })
    .state('testCateringSelfDelivery', {
      url: '/testCateringSelfDelivery',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCateringSelfDelivery(); }
      }
    })
    .state('testCateringOrderNoLineInfo', {
      url: '/testCateringOrderNoLineInfoFutureGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCateringOrderNoLineInfo(); }
      }
    })
    .state('testSgoOrder', {
      url: '/testSgoOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSgoOrder(); }
      }
    })
    .state('testSgoGhdOrder', {
      url: '/testSgoGhdOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSgoGhdOrder(); }
      }
    })
    .state('testSgoOrderAllActive', {
      url: '/testSgoOrderAllActive',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSgoOrderAllActive(); }
      }
    })
    .state('testSgoOrderAdjusted', {
      url: '/testSgoOrderAdjusted',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSgoOrderAdjusted(); }
      }
    })
    .state('testSgoOrderCancelledDiners', {
      url: '/testSgoOrderCancelledDiners',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSgoOrderCancelledDiners(); }
      }
    })
    .state('testSgoOrderCancelledOrder', {
      url: '/testSgoOrderCancelledOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSgoOrderCancelledOrder(); }
      }
    })
    .state('testDmpOrderSummary', {
      url: '/testDmpOrderSummary',
      component: 'home',
      resolve: {
          confirmTemplateModel: function(homeService) { return homeService.testDmpOrderSummary(); }
      }
    })
    .state('testContactFreeDelivery', {
      url: '/testContactFreeDelivery',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testContactFreeDelivery(); }
      }
    })
    .state('testCurbsidePickupNonGHD', {
      url: '/testCurbsidePickupNonGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCurbsidePickupNonGHD(); }
      }
    })
    .state('testCurbsidePickupGHD', {
      url: '/testCurbsidePickupGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCurbsidePickupGHD(); }
      }
    })
    .state('testCurbsideAndContactlessDelivery', {
      url: '/testCurbsideAndContactlessDelivery',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCurbsideAndContactlessDelivery(); }
      }
    })
    .state('testCurbsideAndContactlessDeliveryGHD', {
      url: '/testCurbsideAndContactlessDeliveryGHD',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testCurbsideAndContactlessDeliveryGHD(); }
      }
    })
    .state('testContactlessNoInstructions', {
      url: '/testContactlessNoInstructions',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testContactlessNoInstructions(); }
      }
    })
    .state('testOnlyInstructions', {
      url: '/testOnlyInstructions',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testOnlyInstructions(); }
      }
    })
    .state('testGhDirectPickupOrder', {
        url: '/testGhDirectPickupOrder',
        component: 'home',
        resolve: {
            confirmTemplateModel: function(homeService) { return homeService.testGhDirectPickupOrder(); }
        }
    })
    .state('testGHDasPickup', {
        url: '/testGHDasPickup',
        component: 'home',
        resolve: {
            confirmTemplateModel: function (homeService) {return homeService.testGHDasPickup();}
        }
    })
    .state('testEstimatedFulfillmentAt', {
      url: '/testEstimatedFulfillmentAt',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testEstimatedFulfillmentAtPickupOrder(); }
      }
    })
    .state("Food prep time confirmed", {
      url: "/confirmed",
      component: "home",
      resolve: {
        confirmTemplateModel: function (homeService) {
          return homeService.getFoodPrepTimeConfirmedOrder();
        },
      },
    })
    .state("Food prep time - test Grubhub delivery with SIM headers", {
      url: `/:authToken/:supervisorToken?foodPrepDefault=${PREP_TIME_DEFAULTS[OrderType.GRUBHUB_DELIVERY]}&orderType=${OrderType.GRUBHUB_DELIVERY}&isSimMode=true`,
      component: "foodPrepTime",
    })
    .state("Food prep time - test self delivery with SIM headers", {
      url: `/:authToken/:supervisorToken?foodPrepDefault=${PREP_TIME_DEFAULTS[OrderType.SELF_DELIVERY]}&orderType=${OrderType.SELF_DELIVERY}&isSimMode=true`,
      component: "foodPrepTime",
    })
    .state("Food prep time - test pickup with SIM headers", {
      url: `/:authToken/:supervisorToken?foodPrepDefault=${PREP_TIME_DEFAULTS[OrderType.PICKUP]}&orderType=${OrderType.PICKUP}&isSimMode=true`,
      component: "foodPrepTime",
    })
    .state('testSingleCartTaxExemptedOrder', {
      url: '/testSingleCartTaxExemptedOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSingleCartTaxExemptedOrder(); }
      }
    })
    .state('testMultiCartTaxExemptedOrder', {
      url: '/testMultiCartTaxExemptedOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testMultiCartTaxExemptedOrder(); }
      }
    })
    .state('testSeamlessOrder', {
      url: '/testSeamlessOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testSeamlessOrder(); }
      }
    })
    .state('testEat24Order', {
      url: '/testEat24Order',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testEat24Order(); }
      }
    })
    .state('testWonderOrder', {
      url: '/testWonderOrder',
      component: 'home',
      resolve: {
        confirmTemplateModel: function(homeService) { return homeService.testWonderOrder(); }
      }
    })
})

.component('home', homeComponent)
.component('testRoutes', testRoutesComponent)
.service('homeService', homeService)
.directive('receipt', function() {
  return {
    template: template,
    scope: {
      ctrl:'='
    }
  }
})
.directive('cancelledReceipt', function() {
  return {
    template: cancelledTemplate,
    scope: {
      ctrl:'='
    }
  }
})
.directive('sgoReceipt', function() {
  return {
    template: sgoTemplate,
    scope: {
      ctrl:'='
    }
  }
})
.directive('logo', function() {
    return {
        template: logo,
        scope: {
          ctrl: '=',
          type: '@'
        }
    }
})
.directive('deliveryAddressPickUpByBox', function() {
    return {
        template: deliveryAddressPickUpByBox,
        scope: {
          ctrl:'='
        }
    }
})
.directive('customerCare', function() {
    return {
        template: customerCare,
        scope: {
          ctrl:'='
        }
    }
})
.directive('corporateCare', function() {
    return {
        template: corporateCare,
        scope: {
          ctrl:'='
        }
    }
})
.directive('restaurantCare', function() {
    return {
        template: restaurantCare,
        scope: {
          ctrl:'='
        }
    }
})
.directive('specialInstructions', function() {
    return {
        template: specialInstructions,
        scope: {
          ctrl:'='
        }
    }
})
.directive('contactFreeInstructions', function() {
    return {
        template: contactFreeInstructions,
        scope: {
            ctrl:'='
        }
    }
})
.directive('curbsidePickupInstructions', function() {
  return {
      template: curbsidePickupInstructions,
      scope: {
          ctrl:'='
      }
  }
})
.directive('adjustmentBar', function() {
    return {
        template: adjustmentBar,
        scope: {
          ctrl:'='
        }
    }
})
.directive('dinerBar', function() {
    return {
        template: dinerBar,
        scope: {
          ctrl:'=',
          diner:'='
        }
    }
})
.directive('scheduledBar', function() {
    return {
        template: scheduledBar,
        scope: {
          ctrl:'='
        }
    }
})
.directive('cancelledBar', function() {
    return {
        template: cancelledBar,
        scope: {
          ctrl:'='
        }
    }
})
.directive('receiptBar', function() {
    return {
        template: receiptBar,
        scope: {
          ctrl:'='
        }
    }
})
.directive('cancellationText', function() {
    return {
        template: cancellationText,
        scope: {
          ctrl:'='
        }
    }
})
.directive('merchantInfo', function() {
    return {
        template: merchantInfo,
        scope: {
          ctrl:'='
        }
    }
})
.directive('deliverBy', function() {
    return {
        template: deliverBy,
        scope: {
          ctrl:'='
        }
    }
})
.directive('orderNumbers', function() {
    return {
        template: orderNumbers,
        scope: {
          ctrl:'='
        }
    }
})
.directive('deliveryOrPickUpBox', function() {
    return {
        template: deliveryOrPickUpBox,
        scope: {
          ctrl:'='
        }
    }
})
.directive('cateringBox', function() {
    return {
        template: cateringBox,
        scope: {
          ctrl:'='
        }
    }
})
.directive('dinerBox', function() {
    return {
        template: dinerBox,
        scope: {
          ctrl:'=',
          diner:'=',
          index:'='
        }
    }
})
.directive('minAdvNoticeBox', function() {
    return {
        template: minAdvNoticeBox,
        scope: {
          ctrl:'='
        }
    }
})
.directive('orderSummaryHeader', function() {
    return {
        template: orderSummaryHeader,
        scope: {
          ctrl:'='
        }
    }
})
.directive('dinerSummaryHeader', function() {
    return {
        template: dinerSummaryHeader
    }
})
.directive('orderSummaryItems', function() {
    return {
        template: orderSummaryItems,
        scope: {
          ctrl:'=',
          lines:'='
        }
    }
})
.directive('orderDinerSummaryRestaurant', function() {
    return {
        template: orderDinerSummaryRestaurant,
        scope: {
          ctrl:'='
        }
    }
})
.directive('prepaidOrCash', function() {
    return {
        template: prepaidOrCash,
        scope: {
          ctrl:'='
        }
    }
})
.directive('restaurantTaxExemptionNotice', function() {
     return {
         template: restaurantTaxExemptionNotice,
         scope: {
           ctrl:'='
         }
     }
 })
.directive('dinerTaxExemptionNotice', function() {
    return {
      template: dinerTaxExemptionNotice,
    }
 })
.directive('orderSummaryNapkinsAndUtensils', function() {
    return {
        template: orderSummaryNapkinsAndUtensils,
        scope: {
          ctrl:'='
        }
    }
})
.directive('orderSummaryCoupons', function() {
    return {
        template: orderSummaryCoupons,
        scope: {
          ctrl:'='
        }
    }
})
.directive('orderSummaryAdjustments', function() {
    return {
        template: orderSummaryAdjustments,
        scope: {
          ctrl:'='
        }
    }
})
.directive('orderSummaryTotals', function() {
    return {
        template: orderSummaryTotals,
        scope: {
          ctrl:'='
        }
    }
})
.directive('dinerSummaryTotals', function() {
    return {
        template: dinerSummaryTotals,
        scope: {
          ctrl:'=',
          diner:'='
        }
    }
})
.directive('deliveryTotalSummary', function() {
    return {
        template: deliveryTotalSummary,
        scope: {
          ctrl: '=',
          type:'@'
        }
    }
})
.directive('orderSummary', function() {
    return {
        template: orderSummary,
        scope: {
          ctrl:'=',
          diner:'='
        }
    }
})
.directive('dinerSummaryRestaurant', function() {
    return {
        template: dinerSummaryRestaurant,
        scope: {
          ctrl:'='
        }
    }
})
.directive('dinerSummaryCustomer', function() {
    return {
        template: dinerSummaryCustomer,
        scope: {
          ctrl:'=',
          diner:'='
        }
    }
})
.directive('logoAndCustCare', function() {
    return {
        template: logoAndCustCare,
        scope: {
          ctrl:'='
        }
    }
})
.directive('deliveryInfo', function() {
    return {
        template: deliveryInfo,
        scope: {
          ctrl:'=',
          isSgoCustomer:'='
        }
    }
})
.directive('endOfOrder', function() {
    return {
        template: endOfOrder
    }
})
.directive('restaurantPage', function() {
    return {
        template: restaurantPage,
        scope: {
          ctrl:'='
        }
    }
})
.directive('customerPage', function() {
    return {
        template: customerPage,
        scope: {
          ctrl:'=',
          diner:'=',
          index:'='
        }
    }
})
.directive('pageSeparator', function() {
    return {
        template: pageSeparator
    }
})
.directive('iconUpdate', function() {
    return {
        template: iconUpdate
    }
})
.directive('orderSummaryCountAndInstructionsTag', function () {
    return {
      template: orderSummaryCountAndInstructionsTag
    }
})
.directive('dinerSummaryCount', function () {
    return {
      template: dinerSummaryCount,
      scope: {
        diner:'='
      }
    }
})
.run(($state, errorService) => {
  "ngInject";
  $state.defaultErrorHandler((error) => {
    errorService.setError(error);
    $state.go('error');
  });
})
.name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js